module.exports = __webpack_public_path__ + "static/media/35.3d674b2c.jpg";